module.exports = __webpack_public_path__ + "static/media/casa-a.0f1b784b.png";